import React from 'react';

export function TabsPanel(props) {
  const { children } = props;

  return <div>{children}</div>;
}
